export const TokenContentKey = {
  TOKEN_CONTENT_ALL: 0,
  TOKEN_CONTENT_PERSON: 1,
  TOKEN_CONTENT_FIREBASE: 2,
  TOKEN_CONTENT_ACCOUNTS: 4,
  TOKEN_CONTENT_PERMISSIONS: 8,
};